/**
 * Say that a read of workspace file data failed, where whoever debugs a user
 * report can find it (FR-067).
 *
 * One implementation for both reads a preview depends on — the file's bytes
 * (`useFileObjectUrl`) and the parent folder's listing
 * (`useWorkspaceFileEntry`) — because the second one used to throw with no
 * warn at all, and the fix for that must not be a second copy of this that
 * drifts from the first.
 *
 * `summary` names the failure kind in the log line — a
 * `FileReadFailureReason` from the content read, or `'listing'` from the
 * folder read. `context` carries the things that make the report
 * actionable — always which workspace and what the server answered, plus
 * whichever of the path or the folder the caller read.
 *
 * Callers must report only reads whose result is still wanted: a preview
 * closed or switched mid-flight (and React 18's double-invoked effect in
 * development) would otherwise log a warning for an answer nobody is
 * waiting for.
 */
export function reportFileReadFailure(
  summary: string,
  context: Record<string, unknown> & {
    workspaceId: string;
    /** Absent when there was no response at all — itself the diagnosis. */
    status: number | undefined;
  },
  error: unknown,
): void {
  console.warn(`workspace file read failed: ${summary}`, context, error);
}
